import {enumerate} from '@peachy/utility-kit-pure'

export const PolicyTypes = enumerate([
    'INDIVIDUAL',
    'SME',
    'VOLUNTARY'
] as const)

export type PolicyType = keyof typeof PolicyTypes